import Modal from '@mui/joy/Modal'
import { ModalDialog } from '@mui/joy'
import Typography from '@mui/joy/Typography'
import Grid from '@mui/joy/Grid'
import Button from '@mui/joy/Button'
import React from 'react'
import { useDeleteRewardMutation } from '../services/rewards'

type RedeemRewardModalProps = {
  isModalOpen: boolean
  currentRewardId: string
  closeModal: () => void
}

function RedeemRewardModal(props: RedeemRewardModalProps) {
  const [deleteReward] = useDeleteRewardMutation({
    fixedCacheKey: 'shared-delete-reward',
  })

  function closeAndDelete() {
    props.closeModal()
    deleteReward(props.currentRewardId)
  }

  return (
    <Modal
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      open={props.isModalOpen}
    >
      <>
        <ModalDialog>
          <Typography level="body-lg" sx={{ mb: 2 }}>
            Mutasd be egy ott dolgozónak és kattints a &apos;Megkaptam&apos;
            gombra, miután megkaptad a terméket.
          </Typography>
          <Typography level="body-lg" sx={{ mb: 2 }}>
            Figyelem! A &apos;Megkaptam&apos; gombra kattintás után beváltottnak
            fogja jelezni a kártyát, és nincs lehetőség visszavonásra.
          </Typography>

          <Grid xs={12} md={12} lg={12} container>
            <Grid>
              <Button
                onClick={props.closeModal}
                color="neutral"
                variant="solid"
              >
                Mégse
              </Button>
            </Grid>
            <Grid sx={{ pl: 2 }}>
              <Button onClick={closeAndDelete} color="danger" variant="solid">
                Megkaptam
              </Button>
            </Grid>
          </Grid>
        </ModalDialog>
      </>
    </Modal>
  )
}

export default RedeemRewardModal
